import { useState } from "react";
import {
  CONSULTATION_ICONS,
  cufrontIcons,
} from "../../cufront-assets/icons/Icons";
import "../css/ConsultationRightBar.css";
import { MdExpandLess } from "react-icons/md";
import { MdExpandMore } from "react-icons/md";
import CuSpinner from "../../common_component/component/CuSpinner";
import SharePrescription from "../component/SharePrescription";

const ConsultationRightBar = ({
  handleSaveConsultation,
  saveLoading,
  endLoading,
  printLoading,
  phone,
  sendNotification,
  isLoading,
  viewCertificate,
}) => {
  const [isExpand, setIsExpand] = useState(true);

  return (
    <div className="cu-consultation-rightbar-container">
      <div className="w-full sticky top-0">
        <div
          className="cu-consultation-rightbar-expand-btn flex justify-center"
          onClick={() => setIsExpand(!isExpand)}
        >
          {isExpand && (
            <MdExpandLess
              size={"30px"}
              className="cu-consultation-rightbar-expand-icon"
            />
          )}
          {!isExpand && (
            <MdExpandMore
              size={"30px"}
              className="cu-consultation-rightbar-expand-icon"
            />
          )}
        </div>
        {isExpand && (
          <div className="cu-consultation-rightbar-other-btns">
            <div className="cu-consultation-rightbar-other-btn">
              <img
                src={cufrontIcons.pin}
                alt="pin"
                className="cu-consultation-rightbar-pin"
                onClick={viewCertificate}
              />
            </div>
            <div className="cu-consultation-rightbar-other-btn">
              {!printLoading && (
                <img
                  src={CONSULTATION_ICONS.print}
                  alt="print"
                  className="cu-consultation-rightbar-print"
                  onClick={() => handleSaveConsultation("draft", "print")}
                />
              )}
              {printLoading && <CuSpinner />}
            </div>
            <div className="cu-consultation-rightbar-other-btn">
              {!saveLoading && (
                <img
                  src={CONSULTATION_ICONS.save}
                  alt="save"
                  className="cu-consultation-rightbar-save"
                  onClick={() => handleSaveConsultation("draft", "save")}
                />
              )}
              {saveLoading && <CuSpinner />}
            </div>
            <div className="cu-consultation-rightbar-other-btn">
              {/* <img
                src={CONSULTATION_ICONS.share}
                alt="share"
                className="cu-consultation-rightbar-share"
              /> */}
              <SharePrescription
                phone={phone}
                sendNotification={sendNotification}
                isLoading={isLoading}
                iconSize={24}
              />
            </div>
            <div className="cu-consultation-rightbar-other-btn ml-1">
              {!endLoading && (
                <img
                  src={CONSULTATION_ICONS.end_consultation}
                  alt="end"
                  className="cu-consultation-rightbar-end-consultation"
                  onClick={() => handleSaveConsultation("published", "end")}
                />
              )}
              {endLoading && <CuSpinner />}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultationRightBar;
